module.exports = __webpack_public_path__ + "media/images/icons/favorite-dark-c3550bb07edfb13396ae6faf3ad2f1ef.svg";